import './App.css';

function App() {
  return (
    <div className="App">
      <h1>Deploy test application</h1>
    </div>
  );
}

export default App;
